import EventPolicyModel from './EventPolicyModel';

class EventPolicyTemplateModel extends EventPolicyModel {
  get isTemplate() {
    return true;
  }

  createPolicyModel() {
    return this.clonePolicy({ status: 'active' });
  }
}

export default EventPolicyTemplateModel;
